import { Button, Modal } from "antd";
import React, { useCallback, useMemo, useState } from "react";
import CreateAccount from "../../pages/dashboard-content/Account/CreateAccount";
import { getContestDetail } from "../../api/contest";
import { useHistory, Link, useParams } from "react-router-dom";
import LoadingIux from "../loading";
import { useSelector } from "react-redux";

const locale = require("react-redux-i18n").I18n;

const ButtonGroup = ({
  status,
  requirement,
  condition,
  size,
  contestId,
  accountID,
  accountNumber,
  disable,
  location,
  userStatus,
  fetchContestMe,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleLearn, setIsModalVisibleLearn] = useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen] = useState(false);
  const history = useHistory();

  const [dataDetail, setDataDetail] = React.useState();

  const [disableAction, setDisableAction] = useState(false);

  const disableActionHandler = useCallback(() => {
    setDisableAction(true);
    if (fetchContestMe) {
      fetchContestMe();
    }
  }, [fetchContestMe]);

  const fetchContestsByID = useCallback(async () => {
    try {
      const response = await getContestDetail({ id: contestId });
      const data = response.data.data || [];
      setDataDetail(data);
    } catch (error) {
      console.error("Error fetching contests:", error);
    }
  }, [contestId]);

  const handleContestClick = () => {
    const locale = localStorage.getItem("locale");

    localStorage.setItem("contestId", contestId);

    const isNewEventsPage = location.pathname.includes("new-events");

    if (isNewEventsPage) {
      return history.push(`/${locale}/wallet/contest/new-events/${contestId}`);
    } else {
      return history.push(
        `/${locale}/wallet/contest/previous-events/${contestId}`
      );
    }
  };

  React.useEffect(() => {
    if (isModalVisible) fetchContestsByID();
  }, [isModalVisible, fetchContestsByID]);

  React.useEffect(() => {
    if (isModalVisibleLearn) fetchContestsByID();
  }, [isModalVisibleLearn, fetchContestsByID]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const showModalLearn = () => {
    setIsModalVisibleLearn(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleCancelLearn = () => {
    setIsModalVisibleLearn(false);
  };

  const getStart = () => {
    setIsModalVisible(false);
    setIsCreateAccountOpen(true);
  };

  const onClose = () => {
    setIsCreateAccountOpen(false);
  };

  const onDelete = () => {
    console.log("Account deleted");
    setIsCreateAccountOpen(false);
  };

  const userData = useMemo(() => {
    return userStatus?.data[0];
  }, [userStatus]);

  return (
    <>
      {size === "horizontal" ? (
        <div style={{ display: "flex", gap: 12 }}>
          {status !== "ended" &&
            (userStatus?.data?.length === 0 ||
            (userData?.status !== "preparing" &&
              userData?.status !== "participate") ? (
              <Button
                className="btn-primary-new-iux"
                style={{ flex: 1, fontWeight: 800 }}
                onClick={showModal}
                disabled={
                  disableAction ||
                  status === "upcoming" ||
                  userData?.status === "not_participate"
                }
              >
                {locale.t("cardContest.button.get_start")}
              </Button>
            ) : (
              <Button
                className="btn-primary-new-iux"
                style={{ flex: 1, fontWeight: 800 }}
                onClick={() => {
                  const locale = localStorage.getItem("locale");
                  if (accountID === null) {
                    return (window.location.href = `/${locale}/wallet/fund`);
                  }
                  return (window.location.href = `/${locale}/wallet/fund/deposit?account=${accountID}`);
                }}
              >
                {locale.t("dashboardContest.deposit")}
              </Button>
            ))}
          <Button
            className="btn-primary-new-outline"
            style={{ flex: 1, fontWeight: 800 }}
            onClick={showModalLearn}
          >
            {locale.t("cardContest.button.learn_more")}
          </Button>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 12 }}>
          {status === "opening" && (
            <Button
              className="btn-primary-new-iux"
              style={{ flex: 1, fontWeight: 800 }}
              onClick={showModal}
              disabled={disable || disableAction}
            >
              {locale.t("cardContest.button.get_start")}
            </Button>
          )}
          <Button
            className="btn-primary-new-outline"
            style={{ flex: 1, fontWeight: 800 }}
            onClick={handleContestClick}
          >
            {locale.t("cardContest.button.view_more")}
          </Button>
        </div>
      )}
      <Modal
        style={{
          width: "400px",
          padding: "24px",
          borderRadius: "12px",
        }}
        visible={isModalVisible}
        footer={null}
        closable={true}
        title={false}
        onCancel={handleCancel}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "800",
              color: "black",
              textAlign: "center",
            }}
          >
            {dataDetail?.name}
          </h2>
          {dataDetail?.content ? (
            <div
              className="html-center-p"
              dangerouslySetInnerHTML={{ __html: dataDetail?.content }}
            />
          ) : (
            <LoadingIux />
          )}
          <Button
            className="btn-primary-new-iux"
            style={{ flex: 1 }}
            onClick={getStart}
          >
            {locale.t("contestAward.next")}
          </Button>
        </div>
      </Modal>
      <Modal
        style={{
          width: "400px",
          padding: "24px",
          borderRadius: "12px",
        }}
        visible={isModalVisibleLearn}
        footer={null}
        closable={true}
        title={false}
        onCancel={handleCancelLearn}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <h2
            style={{
              fontSize: "20px",
              fontWeight: "800",
              color: "black",
              textAlign: "center",
            }}
          >
            {dataDetail?.name}
          </h2>
          {dataDetail?.content ? (
            <div
              className="html-start-p"
              dangerouslySetInnerHTML={{ __html: dataDetail?.content }}
            />
          ) : (
            <LoadingIux />
          )}
        </div>
      </Modal>
      <CreateAccount
        isOpen={isCreateAccountOpen}
        onClose={onClose}
        onDeleteAccount={onDelete}
        isAccountTypeID={accountNumber}
        isContest
        contestId={contestId}
        actionAfterSuccess={disableActionHandler}
      />
    </>
  );
};

export default ButtonGroup;
